<template>
    <div class="c2-task-main" v-if="bodyShow">
        <h2>{{title}}</h2>
        <public-dialogue v-if="data.testid&&data.testid != 0" :testid="data.testid" :cid="$route.query.cid" :taskid="$route.query.id"></public-dialogue>
        <!--  -->
        <div v-for="(item,index) in list" :key="index">
            <!-- title -->
            <div v-if="item.type == 'title'" class="c2-task-group" :style="{marginTop:(item.config?(item.config.top/2):'15')+'px'}">
                <!-- 处理字体颜色  -----参数:标题、需要变色的文字、颜色值、说明 -->
                 <h3  v-html="doFontColor(item)"></h3>
            </div>
            <!-- text -->
            <div v-if="item.type=='text'" class="c2-task-group text">
                <h3 v-if="item" v-html="doFontColor(item)"></h3>
                <div class="task-group-text">
                    <textarea :style="{marginTop:(item.config?(item.config.top/2):'10')+'px'}" class="c2-textarea" @input="textareaChange(index,item.content,item.id,item.config.word)" v-model="item.content" :placeholder="item.config.placeholder" ></textarea>
                    <span class="c2-word-limit">{{item.content?item.content.length:0}}/{{item.config.word}}</span>
                </div>
            </div>
            <!-- subtitle -->
            <div v-if="item.type=='subtitle'" class="c2-task-group subtitle">
                <small class="small subtitle" v-html="doFontColor(item)" :style="item.config?style(item.config):''" ></small>
            </div>
            <!-- textarea -->
            <div v-if="item.type == 'textarea'" class="c2-task-group textarea">
                <h3 v-if="item" v-html="doFontColor(item)"></h3>
                <div class="task-group-text">
                    <textarea :style="{marginTop:(item.config?(item.config.top/2):'10')+'px'}" class="c2-textarea" @input="textareaChange(index,item.content,item.id,item.config.word)" v-model="item.content" :placeholder="item.config.placeholder" ></textarea>
                    <span class="c2-word-limit">{{item.content?item.content.length:0}}/{{item.config.word}}</span>
                </div>
                <small class="small" v-if="item.config.subtitle"><span>*</span>{{item.config.subtitle.text}}</small>
            </div>

        </div>
        <!-- 引入项目攻略入口 -->
        <task-strategy :cid="$route.query.cid" :pid="$route.query.pid"></task-strategy>
        <!-- submit -->
        <button :class="['c-submit',bool?'on':'']" @click="submithandle">提交</button>

    </div>
</template>

<script>
import { index, subtable } from "@/api/course"
import { getStorage, setStorage,deepCopy } from "@/utils/tools"
import { shareCon } from "@/utils/wxconfig"
import TaskStrategy from "@c/course/task-strategy"
export default {
    data() {
        return{
            bodyShow:false,
            title:'',
            list:[],
            userfield:[],
            bool:true,
            word_num:0,
            data:{},
        }
    },
    components:{
        TaskStrategy
    },
    computed:{
    /*
     *@param:
     *@return:
     *@Description: 标题样式
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-10-30 12:06:12
    */
        style(){
            return function(config) {
                return (config.typeSet && config.typeSet[0] && config.typeSet[0].fontsize)?`font-size:${config.typeSet[0].fontsize/2}px;`:''
            }
        }
    },
    methods:{
        // 改变字体颜色
        doFontColor(item){
            let font = item.label;
            let typeSet = item.config.typeSet?item.config.typeSet:'';
            let subtitle = item.config.subtitle?item.config.subtitle:'';

            // small是括号里的说明
            if(typeSet instanceof Array){
                typeSet.forEach((item,idx)=>{
                    font = font.replace(item.text,(v)=>{
                        return v.fontcolor(item.color)
                    })+((subtitle && subtitle.position!='bottom')?"<span class='small'>"+subtitle.text+"</span>":'');
                });
                return font;
            }else if(typeSet.text instanceof Array) {
                typeSet.text.forEach((item,idx)=>{
                    font = font.replace(item,(v)=>{
                        return "<span>"+ v.fontcolor(typeSet.color) +"</span>"
                    })+((subtitle && subtitle.position!='bottom')?"<span class='small'>"+subtitle.text+"</span>":'');
                });
                return font;
            } else {
                return font.replace(typeSet.text,(v)=>{
                    return "<span>"+ v.fontcolor(typeSet.color) +"</span>"
                })+((subtitle && subtitle.position!='bottom')?"<span class='small'>"+subtitle.text+"</span>":'');
            }
        },
        //改变输入框时触发------- 下标、内容、id、字数长度
        textareaChange(index,content,id,word,val){
            this.$forceUpdate();
            if(content && content.length > word) {
                this.$set(this.list[index],'content',content.slice(0, word));
		        this.$toast(`最多只能输入${word}个字。/(ㄒoㄒ)/~~`);
		    }else{
		    	setStorage(this.$route.path, 'id'+id, content);
            }
            this.validationHandle();
        },
        pullData(){
            // loading
            this.$toast.loading({
                mask: true,
                message: "加载中..."
            });
            // 获取页面初始化数据
            index({
                cid: this.$route.query.cid,
                cpid: this.$route.query.pid,
                cptid: this.$route.query.id
            }).then((data)=>{
            this.$toast.clear();
            if(data.code===10002){
                this.$toast(data.data.msg);
                return
            }
                this.list = data.field;
                this.userfield = data.userfield;
                document.title = this.$route.query.name;
                this.title = data.title;
                this.data = data;
                this.validationHandle(true);
                this.bodyShow = true;
            });
        },
        validationHandle(bl){
            let b = true;
            if(this.list && this.list.length==0){
                this.bool = false;
                return
            }
            this.list.forEach((item,index)=>{
                // 判断是否是初始化
                if(bl){
                     // 判断是否已提交过数据
                    if(this.userfield && this.userfield.length>0){
                        this.userfield.forEach((item2,key)=>{
                            if(this.list[index].content){
                                return
                            }
                            if(item2.content && item2.field_id == item.id){
                                this.list[index].content = item2.content;
                            }
                        });
                    }else{
                        this.list[index].content = this.list[index].content?this.list[index].content:getStorage(this.$route.path, 'id'+item.id) || '';
                    }
                }
                // 判读是否有空
                if((this.list[index].type=='text' || this.list[index].type=='textarea')&&(!this.list[index].content || this.list[index].content=='')){
                    b =false;
                }
            });
            this.bool = b;
        },
        submithandle(){
            if(this.bool){
                let arr = [];
                this.list.forEach((item,index)=>{
                    if(item.content){
                        arr.push({
                            field_id:item.id,
                            content:item.content
                        });
                    }
                });
                subtable({
                    cid:this.$route.query.cid,
                    form_id:this.list[0].form_id,//引入form_id都是一样的，所以取一个就可以
                    field:JSON.stringify(arr)
                }).then((data)=>{
                    this.$toast({
                        duration: 1000,
                        message: '提交成功！',
                        onClose:()=>{
                            this.$router.push({
                                path:'/project_report',
                                query:{
                                    cid:this.$route.query.cid,
                                    cpid:this.$route.query.pid,
                                    taskid: this.$route.query.id
                                }
                            });
                        }
                    });
                });
            }
        }
    },
    created(){
        this.pullData();
        shareCon("course2",this);
    }
}
</script>

<style lang="scss" scope>
    .c2-task-main{
        padding: 40px 30px 80px;
        text-align: center;
        background-color: #f0f0f0;
        h2{
            font-weight: bold;
            font-size: 36px;
            color: #333333;
            text-align: center;
        }
        .c2-task-group{
            margin-top: 30px;
            position: relative;
            text-align: left;
            .task-group-text{
                position: relative;
            }

            h3{
                text-align: left;
                font-size: 32px;
                color: #333333;
            }
            .c2-textarea{
                margin-top: 20px;
                height: 160px;
                border-radius: 8px;
                background-color: #fff;
                border: 0;
                width: 100%;
                padding: 22px 20px;
                font-size: 26px;
                resize:none;
                text-align: left;
            }
            .c2-word-limit{
                position: absolute;
                font-size: 18px;
                color: #999;
                bottom: 14px;
                right: 16px;
            }
            span.small{
                font-size:24px;
                color: #666666;
                span{
                    color: #EA345C;
                    margin-right: 5px;
                }
            }
        }
        .c2-task-group.-mt{
            margin-top: 50px;
        }
        .c2-task-group.mt0{
            margin-top: 0px;
        }
        .c2-task-group.mt4{
            margin-top: 40px;
        }

        .c2-task-group.subtitle{
            margin-top: 20px;
        }
        .c2-task-group.text{
            margin-top: 30px;
            h3{
                color: #333333;
                line-height: 1;
            }
            .task-group-text{
                position: relative;
            }
            .c2-textarea{
                margin-top: 20px;
                height: 70px;
                line-height: 70px;
                padding: 0px 20px;
            }
        }
        .c2-task-group.text,.c2-task-group.textarea{
            margin-top: 0;
        }
        .c-submit{
            width:174px;
            height:66px;
            background:#CCCCCC;
            border-radius:33px;
            font-size: 34px;
            color: #FFFFFF;
            border: 0;
            margin: 80px auto auto;
        }
        .c-submit.on{
            background-color: #EA345C;
        }
    }
</style>